import { cn } from '@/lib/cn';

interface SkeletonProps {
  className?: string;
  /** Render as a circle. */
  circle?: boolean;
  /** Aspect-ratio shorthand for image placeholders. */
  aspect?: '1:1' | '3:4' | '4:5' | '16:9';
}

const aspects: Record<NonNullable<SkeletonProps['aspect']>, string> = {
  '1:1': 'aspect-square',
  '3:4': 'aspect-[3/4]',
  '4:5': 'aspect-[4/5]',
  '16:9': 'aspect-video',
};

export function Skeleton({ className, circle = false, aspect }: SkeletonProps) {
  return (
    <div
      role="status"
      aria-busy="true"
      aria-live="polite"
      className={cn(
        'skeleton-shimmer',
        circle ? 'rounded-full' : 'rounded-md',
        aspect && aspects[aspect],
        className
      )}
    />
  );
}

/* ── Pre-composed product skeletons used across listing pages ────────────── */

export function ProductCardSkeleton() {
  return (
    <article className="flex flex-col gap-3">
      <Skeleton aspect="3:4" />
      <Skeleton className="h-3 w-1/3" />
      <Skeleton className="h-5 w-3/4" />
      <Skeleton className="h-4 w-1/4" />
    </article>
  );
}

export function ProductGridSkeleton({ count = 12 }: { count?: number }) {
  return (
    <div className="grid grid-cols-2 gap-x-4 gap-y-8 md:grid-cols-3 lg:grid-cols-4">
      {Array.from({ length: count }).map((_, i) => (
        <ProductCardSkeleton key={i} />
      ))}
    </div>
  );
}
